import { GRANULARITIES } from '../../config/constants';

// Daily / Monthly / Yearly switch.
export function PeriodToggle({ value, onChange }) {
  return (
    <div className="inline-flex rounded-full border border-slate-200 dark:border-white/10 bg-slate-100/70 dark:bg-white/5 p-1">
      {GRANULARITIES.map((g) => (
        <button
          key={g.value}
          type="button"
          onClick={() => onChange(g.value)}
          className={`rounded-full px-3.5 py-1.5 text-sm font-medium transition ${
            value === g.value ? 'bg-brand-gradient text-white shadow-brand' : 'text-slate-600 dark:text-slate-300 hover:text-slate-800 dark:hover:text-white'
          }`}
        >
          {g.label}
        </button>
      ))}
    </div>
  );
}
